import { createElement } from 'react'

type Props = {
  url: string | undefined | null
}

// TODO: Move logic to page specific metadata function in app router
export const RenderExternalStyle = ({ url }: Props) => {
  if (!url) return null

  return createElement('link', {
    rel: 'stylesheet',
    href: url,
  })
}
